<template>
    <div>
        <div class="authorize-btns">
            <div @click="pageChange('lawservice', 'to-vip-center-btn')">前往会员中心查看全部权益</div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isSubmitting: false
        };
    },
    methods: {
        /**
         * 切换页面
         * @param {String} route 路由名称
         * @param {String} area 打点area
         */

        pageChange(route, area) {
            area && this.$wywLog.send({
                serverId: 17078,
                action: 'click',
                area
            });
            this.$router.push({
                name: route
            });
        }
    }
};
</script>

<style lang='less' scoped>
.authorize-btns {
    display: flex;
    margin-top: 14px;
    justify-content: center;

    div {
        height: 34px;
        width: 400px;
        background: #fff;
        border: 1px solid #dedfe0;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #1e1f24;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        cursor: pointer;
    }
}
</style>
